import React, { useEffect, useRef } from 'react';

/**
 * Dropdown Menu Component
 * Handles dropdown menu functionality with keyboard navigation
 */
const DropdownMenu = () => {
	const menuRef = useRef( null );

	useEffect( () => {
		// Add keyboard navigation support
		const handleKeyNavigation = ( e ) => {
			const menuItems = document.querySelectorAll( '.primary-menu > li > a' );
			const currentIndex = Array.from( menuItems ).indexOf( document.activeElement );

			switch ( e.key ) {
				case 'ArrowRight':
					e.preventDefault();
					if ( currentIndex < menuItems.length - 1 ) {
						menuItems[ currentIndex + 1 ].focus();
					} else {
						menuItems[ 0 ].focus();
					}
					break;

				case 'ArrowLeft':
					e.preventDefault();
					if ( currentIndex > 0 ) {
						menuItems[ currentIndex - 1 ].focus();
					} else {
						menuItems[ menuItems.length - 1 ].focus();
					}
					break;

				case 'ArrowDown':
					e.preventDefault();
					const parentLi = document.activeElement.parentElement;
					const submenu = parentLi.querySelector( '.sub-menu' );
					if ( submenu ) {
						const firstSubmenuItem = submenu.querySelector( 'a' );
						if ( firstSubmenuItem ) {
							firstSubmenuItem.focus();
						}
					}
					break;

				case 'ArrowUp':
					e.preventDefault();
					const currentLi = document.activeElement.parentElement;
					if ( currentLi.parentElement.classList.contains( 'sub-menu' ) ) {
						const parentMenuItem = currentLi.parentElement.parentElement.querySelector( 'a' );
						if ( parentMenuItem ) {
							parentMenuItem.focus();
						}
					}
					break;

				case 'Escape':
					const submenuItem = document.activeElement.closest( '.sub-menu' );
					if ( submenuItem ) {
						const parentLink = submenuItem.parentElement.querySelector( ':scope > a' );
						if ( parentLink ) {
							parentLink.focus();
						}
					}
					break;

				default:
					break;
			}
		};

		const primaryMenu = document.querySelector( '.primary-menu' );
		if ( primaryMenu ) {
			primaryMenu.addEventListener( 'keydown', handleKeyNavigation );
		}

		return () => {
			if ( primaryMenu ) {
				primaryMenu.removeEventListener( 'keydown', handleKeyNavigation );
			}
		};
	}, [] );

	return null; // Dropdown functionality is handled by CSS and keyboard navigation
};

export default DropdownMenu;
